import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Priority'),"hide-details":"auto","outlined":"","type":"number"},model:{value:(_vm.priority),callback:function ($$v) {_vm.priority=_vm._n($$v)},expression:"priority"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }